// Copyright (C) 2024 Cloudflare Configuration for Stremio Web

// Cloudflare torrent optimizer configuration
const CLOUDFLARE_TORRENT_OPTIMIZERS = [
    'https://torrentio.strem.fun/', // Official Torrentio (frequent downtime)
    'https://comet.elfhosted.com/', // Comet - reliable alternative
    'https://mediafusion.elfhosted.com/', // MediaFusion - good alternative
    'https://annatar.elfhosted.com/', // Annatar - another alternative
    'https://jackettio.elfhosted.com/', // Jackettio - Jackett-based
    'https://orionoid.com/', // Orion - premium option
    'https://stremthru.elfhosted.com/' // StremThru - newer option
];

// Default Cloudflare optimizer (using most reliable alternative)
const DEFAULT_CLOUDFLARE_OPTIMIZER = 'https://comet.elfhosted.com/';

// Configuration for browser-based streaming
const BROWSER_CONFIG = {
    // Use Cloudflare Workers for torrent processing
    useCloudflareWorkers: true,
    
    // Enable direct browser streaming
    enableBrowserStreaming: true,
    
    // Disable local server dependency
    disableLocalServer: true,
    
    // Use HTTPS for all requests
    forceHTTPS: true,
    
    // Cache settings for Cloudflare
    cacheSettings: {
        enableCaching: true,
        cacheDuration: 3600, // 1 hour
        maxCacheSize: 100 * 1024 * 1024 // 100MB
    },
    
    // Streaming configuration
    streaming: {
        // Use WebRTC for peer-to-peer connections
        useWebRTC: true,
        
        // Enable Media Source Extensions (MSE)
        useMSE: true,
        
        // Buffer settings
        bufferSize: 10 * 1024 * 1024, // 10MB
        bufferTime: 30, // 30 seconds
        
        // Quality settings
        maxQuality: '1080p',
        preferredQuality: '720p'
    }
};

// Export configuration
module.exports = {
    CLOUDFLARE_TORRENT_OPTIMIZERS,
    DEFAULT_CLOUDFLARE_OPTIMIZER,
    BROWSER_CONFIG
};